<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e7lwgr/tc-custom/9781504074285.jpg?1703216930329" alt="This image is the cover for the book Hunter from the Woods, The Michael Gallatin Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hunter from the Woods, The Michael Gallatin Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling author presents five paranormal adventures featuring the lycanthropic British spy introduced in <i>The Wolf’s Hour</i>.</b><br/><br/> Roaming the globe in a fight against Nazi Germany, shapeshifter Michael Gallatin stars in stories that are “tremendous fun as McCammon mashes 007 and the Wolfman in a <i>League of Extraordinary Gentleman</i> fashion” (<i>SFcrowsnest</i>).<br/><br/><b>“The Great White Way”</b><br/><br/> In 1927, the wife of the star wrestler in a Russian traveling circus suffers at her husband’s hand. She finds solace in the arms of the boy who cares for the animals, a young man whose true nature is yet to be revealed . . .<br/><br/><b>“The Man from London”</b><br/><br/> A British Secret Service operative follows rumors of a shapeshifter to a small Russian village. There, he comes face to face with someone who can be fashioned into a unique weapon. A man whose name is Mikhail Gallatinov.<br/><br/><b>“Sea Chase”</b><br/><br/> Arriving in Danzig, Michael Gallatin gets a job as a seaman. His mission: to infiltrate the crew. The ship harbors a weapons expert fleeing the Nazis, and the Germans will stop at nothing to halt his escape.<br/>  <br/><b>“The Wolf and the Eagle”</b><br/>  <br/> After their planes crash over the Libyan desert, Gallatin finds himself in the company of a German Messerschmitt ace. Together, they struggle to survive the heat, the scorpions, and a warlike tribe of scavengers . . .<br/>  <br/><b>“Death of a Hunter”</b><br/>  <br/> At forty-eight, Gallatin is no longer the man—or the wolf—he once was. But what he faces at the hands of deadly ninja warriors may be a fate worse than death . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert McCammon
      </h2>
      
      <p class="authorDescription body article">Robert McCammon (b. 1952) is one of the country&rsquo;s most accomplished authors of modern horror and historical fiction, and a founder of the Horror Writers Association. Raised by his grandparents in Birmingham, Alabama, Bram Stoker and World Fantasy Award&ndash;winning McCammon published his first novel, the Revelations-inspired <I>Baal</I>, when he was only twenty-six. His writings continued in a supernatural vein throughout the 1980s, as he produced such bestselling titles as <I>Swan Song</I>, <I>The Wolf&rsquo;s Hour</I>, and <I>Stinger</I>.<BR /><BR /> In 1991, <I>Boy&rsquo;s Life</I> won the World Fantasy Award for best novel. After his next novel, <I>Gone South</I>, McCammon took a break from writing to spend more time with his family. He did not publish another novel until 2002&rsquo;s <I>Speaks the Nightbird</I>. Since then, he has followed &ldquo;problem-solver&rdquo; Matthew Corbett through seven sequels, in addition to writing several non-series books, including <I>The Border </I>and <I>The Listener</I>. McCammon still lives in Birmingham.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?310fc671